module.exports = {"230524100":"饶河镇","230524101":"小佳河镇","230524102":"西丰镇","230524103":"五林洞镇","230524200":"西林子乡","230524201":"四排乡","230524203":"大佳河乡","230524204":"山里乡","230524207":"大通河乡","230524400":"小佳河林场","230524401":"威山林场","230524402":"西丰林场","230524403":"大牙克林场","230524404":"石场林场","230524405":"宝马山林场","230524406":"大岱林场","230524407":"永幸林场","230524408":"奇源林场","230524409":"芦源林场","230524410":"五林洞林场","230524500":"饶河农场","230524501":"红旗岭农场","230524502":"八五九农场","230524503":"胜利农场","230524504":"红卫农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230524.json
// module id = 673
// module chunks = 0